module.exports = __webpack_public_path__ + "img/loxostege-sticticalis.c721adde.jpg";